import { ArrowSmallDown, ArrowUp } from '@sqs/rosetta-glyphs';
import { Flex, Text } from '@sqs/rosetta-primitives';
import React from 'react';
import { usePlatformBreakpoint } from '../../../hooks/usePlatformBreakpoint';
import { useI18n } from '../../../i18n';
import { TooltipIcon } from './TooltipIcon';
import type { TableColumn } from '@sqs/rosetta-compositions';

interface TableHeaderProps {
  readonly column: TableColumn<any, string>;
  readonly label: string;
  readonly tooltip?: string | React.ReactNode;
}

export const TableHeader = ({ column, label, tooltip }: TableHeaderProps) => {
  const { isMobile } = usePlatformBreakpoint();
  const { t } = useI18n();

  const showTooltip = tooltip && !isMobile;

  const getSortIcon = () => {
    if (isMobile) {
      return null;
    }
    if (column.getIsSorted()) {
      if (column.getIsSorted() === 'desc') {
        return <ArrowUp />;
      }
      return <ArrowSmallDown />;
    }
    return null;
  };

  if (!(column.id && column.getCanSort())) {
    return (
      <Text.Label>
        <Flex justifyContent="flex-start" alignItems="center" gap={'3px'}>
          {label}
          {showTooltip ? <TooltipIcon id={column.id} tooltipContent={tooltip} /> : null}
        </Flex>
      </Text.Label>);

  }

  const sortedLabel =
  column.getIsSorted() === 'desc' ? t("descending",
  {}, { project: 'enterprise-dashboard' }) : t("ascending",
  {}, { project: 'enterprise-dashboard' });
  const ariaLabel = `${label} ${column.getIsSorted() ? sortedLabel : t("unsorted", {}, { project: 'enterprise-dashboard' })}`;

  return (
    <Text.Label>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        role="button"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          if (!isMobile && column.id) {
            column.toggleSorting();
          }
        }}>

        <Flex justifyContent="flex-start" alignItems="center" gap={'3px'} aria-label={ariaLabel}>
          {label}
          {showTooltip ? <TooltipIcon id={column.id} tooltipContent={tooltip} /> : null}
          {getSortIcon()}
        </Flex>
      </a>
    </Text.Label>);

};